import * as React from 'react';

import { MultiraceType, Race } from '@/lib/apollo/types/gen/graphql';
import { raceSelector } from '@/selectors/race';

import { TableData } from '../style';
import ResultCharilotoDokanto7 from './CharilotoDokanto7';
import ResultDokanto4Two from './Dokanto4Two';
import { WaitIcon } from './style';

interface ResultDataProps {
  race: Race;
  multiraceType: MultiraceType;
  isCanceled: boolean;
}

const ResultData: React.FC<ResultDataProps> = ({
  race,
  multiraceType,
  isCanceled,
}) => {
  // 確定待ちかどうか
  const isWaitingForDicision = race.entryRacers.some(
    er => er.updateNotificationNum === 0,
  );

  if (isCanceled || raceSelector(race).isCanceled) {
    return <TableData>中止</TableData>;
  }

  if (isWaitingForDicision) {
    return (
      <TableData>
        <WaitIcon />
      </TableData>
    );
  }

  return (
    <TableData>
      {multiraceType === MultiraceType.Dokanto4two ? (
        <ResultDokanto4Two entryRacers={race.entryRacers} />
      ) : (
        <ResultCharilotoDokanto7 entryRacers={race.entryRacers} />
      )}
    </TableData>
  );
};

export default ResultData;
